import { $, $$ } from '../utils/query-selector.js'

class RangeField {
  constructor (el) {
    this.el = el
    this.input = $("input[type='range']", el)
    this.inputWrapper = this.input.parentElement
    this.output = $('output', el)
    this.marks = JSON.parse(el.dataset.marks)

    this.initMarks()

    this.input.addEventListener('input', () => this.update())
    this.update()
  }

  initMarks () {
    const min = parseInt(this.input.getAttribute('min'), 10)
    const max = parseInt(this.input.getAttribute('max'), 10)

    const marksList = document.createElement('ul')
    marksList.className = 'o-input__range-marks'

    for (const v of Object.keys(this.marks)) {
      if (v === '*') {
        continue
      }

      const markValue = parseInt(v, 10)
      const pos = (markValue - min) / (max - min)

      const mark = document.createElement('span')
      mark.className = 'o-input__range-mark'
      mark.style.setProperty('--position', `${pos * 100}%`)
      marksList.appendChild(mark)
    }

    this.inputWrapper.appendChild(marksList)
  }

  update () {
    let result = this.input.value

    if (typeof this.marks[result] !== 'undefined') {
      result = this.marks[result]
    } else if (typeof this.marks['*'] !== 'undefined') {
      result = this.marks['*'].replace(/\{\s*value\s*}/g, result)
    }

    this.output.innerText = result
  }
}

function initField (el) {
  const type = el.dataset.type

  if (type === 'range') {
    /* eslint-disable-next-line no-new */
    new RangeField(el)
  }
}

const fields = $$('.js-field')

for (const field of fields) {
  initField(field)
}
